import Vue from '@src/main.js'

// Erros e alertas

export const simpleSuccess = (text) => {
    return Vue.$swal({
        button: false,
        timer: 3000,
        icon: 'success',
        title: Vue.$t(`Alerts.${text}`),
    })
}

export const simpleError = (text) => {
    return Vue.$swal({
        button: false,
        timer: 3000,
        icon: 'error',
        title: Vue.$t(`Alerts.${text}`),
    })
}

export const simpleWarning = (text) => {
    return Vue.$swal({
        button: false,
        timer: 3000,
        icon: 'warning',
        title: Vue.$t(`Alerts.${text}`),
    })
}

export const requestError = (text) => {
    return Vue.$swal({
        button: false,
        timer: 3000,
        icon: 'warning',
        title: text,
    })
}

export const deleteAction = ({
    title = false,
    text = false,
    cancelText = false,
    confirmText = false,
} = {}) => {
    return Vue.$swal({
        title: Vue.$t(title || 'Alerts.sure'),
        text: Vue.$t(text || 'Alerts.deleteAlert'),
        icon: 'warning',
        buttons: {
            cancel: {
                text: Vue.$t(cancelText || 'Alerts.cancel'),
                value: null,
                visible: true,
                className: 'swal-button--cancel-delete',
                closeModal: true,
            },
            confirm: {
                text: Vue.$t(confirmText || 'Buttons.delete'),
                value: true,
                visible: true,
                className: 'swal-button--confirm-delete',
                closeModal: true,
            },
        },
    })
}

export const confirmAction = ({
    title = false,
    text = false,
    cancelText = false,
    confirmText = false,
    titleVariable = '',
    textVariable = '',
} = {}) => {
    return Vue.$swal({
        title: Vue.$t(title || 'Alerts.sure', titleVariable),
        text: Vue.$t(text || '', textVariable),
        icon: 'warning',
        buttons: {
            cancel: {
                text: Vue.$t(cancelText || 'Alerts.cancel'),
                value: null,
                visible: true,
                className: 'swal-button--cancel',
                closeModal: true,
            },
            confirm: {
                text: Vue.$t(confirmText || 'Alerts.deleteAction'),
                value: true,
                visible: true,
                className: 'swal-button--confirm',
                closeModal: true,
            },
        },
    })
}

export const imgAlert = ({
    title = false,
    text = false,
    confirmText = false,
    titleVariable = '',
    textVariable = '',
    /* imgUrl = '', */
} = {}) => {
    return Vue.$swal({
        title: Vue.$t(title || 'Alerts.sure', titleVariable),
        text: Vue.$t(text || '', textVariable),
        icon: 'warning',
        /* imgAlert:  <img src={imgUrl} alt="img"/>, */
        buttons: {
            confirm: {
                text: Vue.$t(confirmText || 'Alerts.deleteAction'),
                value: true,
                visible: true,
                className: 'swal-button--confirm',
                closeModal: true,
            },
        },
    })
}
